import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HostCommunicationStore {
  private readonly _hostSource = signal<string | null>(null);
  public readonly hostSource = this._hostSource.asReadonly();

  setHostSource(hostSource: string | null): void {
    this._hostSource.set(hostSource);
  }
}
